import { FormBase } from 'core/components';

export default class ESignPreferenceEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'ESIGN_PREFERENCE.EDIT.NAME_LABEL',
                    placeholder: 'ESIGN_PREFERENCE.EDIT.NAME_PLACEHOLDER',
                    rules: ['string', 'required'],
                },
            ],
        };
    }
}
